module.exports = __webpack_public_path__ + "static/media/权益二@2x.5b902ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/权益二@2x.png
// module id = 1137
// module chunks = 0